const C = {
  name: "UserHeart",
  dimensions: { width: 40, height: 40 },
  content: `
    <g fill="currentColor" stroke="none">
      <path d="M18 2C21.31 2 24 4.69 24 8C24 11.31 21.31 14 18 14C14.69 14 12 11.31 12 8C12 4.69 14.69 2 18 2ZM18 16C22.41 16 26 12.41 26 8C26 3.59 22.41 0 18 0C13.59 0 10 3.59 10 8C10 12.41 13.59 16 18 16Z"/>
      <path d="M25 18H11C4.93 18 0 22.93 0 29V39C0 39.55 0.45 40 1 40C1.55 40 2 39.55 2 39V29C2 24.04 6.04 20 11 20H25C29.96 20 34 24.04 34 29V39C34 39.55 34.45 40 35 40C35.55 40 36 39.55 36 39V29C36 22.93 31.07 18 25 18Z"/>
      <path d="M18.06 35.82C16.29 34.52 13 31.58 13 29C13 28.67 13.1 27 15 27C16.83 27 16.99 28.54 17 29C17 29.55 17.45 30 18 30C18.55 30 19 29.55 19 29C19 28.67 19.1 27 21 27C22.83 27 22.99 28.54 23 29C23 32.52 19.41 35.01 18.06 35.82ZM21 25C19.61 25 18.64 25.54 18 26.28C17.36 25.54 16.39 25 15 25C12.07 25 11 27.39 11 29C11 33.48 17.18 37.66 17.45 37.83C17.61 37.94 17.81 38 18 38C18.15 38 18.31 37.96 18.45 37.89C18.71 37.76 25 34.55 25 29C25 27.39 23.93 25 21 25Z"/>
    </g>
  `
};
export {
  C as UserHeart
};
